import React, { useEffect } from 'react';
import { X, CheckCircle, AlertCircle } from 'lucide-react';

export default function CustomAlert({ 
  type = 'success', 
  title = '', 
  message = '', 
  onClose = () => {},
  autoClose = true,
  duration = 4000
}) {
  useEffect(() => {
    if (autoClose) {
      const timer = setTimeout(onClose, duration);
      return () => clearTimeout(timer);
    }
  }, [autoClose, duration, onClose]);

  const bgColor = type === 'success' ? 'bg-green-50' : 'bg-red-50';
  const borderColor = type === 'success' ? 'border-green-200' : 'border-red-200';
  const textColor = type === 'success' ? 'text-green-800' : 'text-red-800';
  const titleColor = type === 'success' ? 'text-green-900' : 'text-red-900';
  const iconColor = type === 'success' ? 'text-green-500' : 'text-red-500';

  return (
    <div className={`fixed top-6 right-6 max-w-md z-50 animate-in fade-in slide-in-from-top-2 duration-300`}>
      <div className={`${bgColor} border ${borderColor} rounded-lg shadow-lg p-4`}>
        <div className="flex items-start gap-3">
          {/* Icon */}
          <div className="flex-shrink-0 pt-0.5">
            {type === 'success' ? (
              <CheckCircle className={`w-5 h-5 ${iconColor}`} />
            ) : (
              <AlertCircle className={`w-5 h-5 ${iconColor}`} />
            )}
          </div>

          {/* Content */}
          <div className="flex-1">
            {title && (
              <h3 className={`font-semibold ${titleColor} mb-1`}>
                {title}
              </h3>
            )}
            <p className={`text-sm ${textColor} leading-relaxed`}>
              {message}
            </p>
          </div>

          {/* Close Button */}
          <button
            onClick={onClose}
            className={`flex-shrink-0 ${textColor} hover:opacity-70 transition-opacity`}
            aria-label="Close alert"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
}
